import { z } from 'zod';

// other scenes deep-link into the chat with ?agentMcpId=<built-in tool-source id>&message=<text>
export const chatSearchParamsSchema = z.object({
  agentMcpId: z.string().optional(),
  message: z.string().optional(),
});

export type ChatSearchParams = z.infer<typeof chatSearchParamsSchema>;
